import React from 'react';
import { Section } from './ui/Section';
import { CheckCircle2, XCircle } from 'lucide-react';
export function ForYou() {
  const isForYou = ['Eres emprendedor o profesional de servicios y quieres dejar de depender solo del boca a boca', 'Quieres posicionarte como el referente en tu área y cobrar lo que realmente mereces', 'Estás cansado de perder clientes frente a competidores que no son mejores que tú pero se ven más profesionales', 'Quieres un activo digital que trabaje por ti todos los días sin que tengas que estar presente', 'Estás listo para invertir en tu negocio de forma estratégica — no en gastos, sino en resultados'];
  const notForYou = ['Buscas la opción más barata del mercado — hay plantillas gratuitas para eso', 'No estás listo para comprometerte seriamente con el crecimiento de tu negocio', 'Quieres resultados sin aportar información sobre tu negocio, visión y clientes ideales'];
  return <Section className="bg-[#0F1525]" data-id="element-163">
      <div className="max-w-5xl mx-auto" data-id="element-164">
        <div className="grid md:grid-cols-2 gap-8 lg:gap-12" data-id="element-165">
          {/* Is For You */}
          <div className="bg-brand-surface border border-emerald-500/20 rounded-3xl p-8 lg:p-10 relative overflow-hidden" data-id="element-166">
            <div className="absolute top-0 left-0 w-full h-1 bg-emerald-500" data-id="element-167"></div>
            <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-3" data-id="element-168">
              <span className="text-emerald-500" data-id="element-169">Esto Es Para Ti Si...</span>
            </h3>
            <ul className="space-y-6" data-id="element-170">
              {isForYou.map((item, index) => <li key={index} className="flex gap-4" data-id="element-171">
                  <CheckCircle2 className="w-6 h-6 text-emerald-500 flex-shrink-0 mt-0.5" data-id="element-172" />
                  <span className="text-slate-300 leading-relaxed" data-id="element-173">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Not For You */}
          <div className="bg-brand-surface border border-red-500/20 rounded-3xl p-8 lg:p-10 relative overflow-hidden" data-id="element-174">
            <div className="absolute top-0 left-0 w-full h-1 bg-red-500" data-id="element-175"></div>
            <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-3" data-id="element-176">
              <span className="text-red-500" data-id="element-177">Esto NO Es Para Ti Si...</span>
            </h3>
            <ul className="space-y-6" data-id="element-178">
              {notForYou.map((item, index) => <li key={index} className="flex gap-4" data-id="element-179">
                  <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-180" />
                  <span className="text-slate-300 leading-relaxed" data-id="element-181">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </Section>;
}